import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor{
    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute
    ){}
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
        return next.handle(request)
            .pipe(
                //retry(1),
                catchError((error: HttpErrorResponse) => {
                    if(error.status == 401){
                        //this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url }});
                        return throwError(error);
                    }
                    else{
                        return throwError(error);
                    }
                })
            )
    }
}